/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */
type TMessage = {
  type: string
  value?: any
}

export function postMessageSharding(message: TMessage, targetOrigin = '*') {
  // window.postMessage(JSON.stringify(message), targetOrigin)
  console.log('postMessageSharding: ', message, targetOrigin)
  window.parent.postMessage(JSON.stringify(message), targetOrigin)
}
